export const MAX_BOQ_IMAGES_PER_ITEM = 3
export const MAX_BOQ_IMAGE_BYTES = 2 * 1024 * 1024
export const BOQ_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']

export function ValidateBoqImageSelection(files, availableSlots = MAX_BOQ_IMAGES_PER_ITEM, { maxImageBytes = MAX_BOQ_IMAGE_BYTES } = {}) {
    const selected = Array.from(files || [])
    const invalidType = selected.filter(file => !BOQ_IMAGE_TYPES.includes(file.type)).length
    const invalidSize = selected.filter(file => BOQ_IMAGE_TYPES.includes(file.type)
        && (!file.size || file.size > maxImageBytes)).length
    const valid = selected.filter(file => BOQ_IMAGE_TYPES.includes(file.type)
        && file.size > 0 && file.size <= maxImageBytes)
    const slots = Math.max(0, availableSlots)
    const accepted = valid.slice(0, slots)
    const overLimit = Math.max(0, valid.length - slots)

    return {
        accepted,
        rejected: invalidType + invalidSize + overLimit,
        invalidType,
        invalidSize,
        overLimit
    }
}
